<template>
  <div>
    <div>
      <div class="desc">
        <div>{{ $t("login.forget.safe_title") }}</div>
        <div>{{ $t("login.forget.safe_tip") }}</div>
      </div>

      <!-- 验证分类 -->
      <div class="valid-type">
        <div
          v-for="tab in tabs"
          :key="tab.key"
          :class="current == tab.key ? 'active' : ''"
          @click="tabChange(tab.key)"
        >
          {{ tab.name }}
        </div>
      </div>

      <div class="main">
        <!-- 手机号验证 -->
        <a-form-model
          v-if="current == 1"
          ref="phoneForm"
          key="phoneForm"
          :model="phoneForm"
          :rules="phoneRules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label=" " class="qu-label" prop="account">
            <div class="mulit-s">
              <a-select default-value="lucy" style="width: 130px">
                <a-select-option value="lucy"
                  >{{ $t("base.mobile.china") }}+86</a-select-option
                >
              </a-select>
              <a-input
                style="margin-left: 10px"
                :placeholder="$t('base.mobile.placeholder')"
                v-model="phoneForm.account"
                class="man-all"
              />
            </div>
          </a-form-model-item>
          <a-form-model-item label=" " class="qu-label" prop="captcha">
            <div class="mulit-s">
              <a-input
                class="man-all"
                :placeholder="$t('base.captcha.placeholder')"
                v-model="phoneForm.captcha"
              />
              <div class="yan-mask">
                <a-button
                  v-if="count == 60"
                  type="primary"
                  @click="getValidMask"
                  >{{ $t("base.btn.get_code") }}</a-button
                >
                <a-button type="primary" disabled v-else>{{ count }}s</a-button>
              </div>
            </div>
          </a-form-model-item>
        </a-form-model>

        <!-- 邮箱验证 -->
        <a-form-model
          v-if="current == 2"
          ref="mailForm"
          key="mailForm"
          :model="mailForm"
          :rules="mailRules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label=" " class="qu-label" prop="account">
            <div class="mulit-s">
              <a-input
                :placeholder="$t('base.email.placeholder')"
                v-model="mailForm.account"
                class="man-all"
              />
            </div>
          </a-form-model-item>
          <a-form-model-item label=" " class="qu-label" prop="captcha">
            <div class="mulit-s">
              <a-input
                class="man-all"
                :placeholder="$t('base.captcha.placeholder')"
                v-model="mailForm.captcha"
              />
              <div class="yan-mask">
                <a-button
                  v-if="count == 60"
                  type="primary"
                  @click="getMailCode"
                  >{{ $t("base.btn.get_code") }}</a-button
                >
                <a-button type="primary" disabled v-else>{{ count }}s</a-button>
              </div>
            </div>
          </a-form-model-item>
        </a-form-model>

        <!-- 问题验证 -->
        <template v-if="current == 3">
          <a-form-model
            v-if="qusForm.qusList.length"
            ref="qusForm"
            :model="qusForm"
            key="qusForm"
            :wrapper-col="{ span: 20, offset: 2 }"
          >
            <a-form-model-item
              v-for="(item, index) in qusForm.qusList"
              :key="index"
              :prop="'qusList.' + index + '.answer'"
              :rules="{
                required: true,
                message: $t('base.question.placeholder'),
              }"
            >
              <a-row :gutter="18" class="flex_form">
                <a-col :span="12">
                  <span>{{ $t("base.question.label") }}{{ index + 1 }}: </span>
                  <div><a-input v-model="item.name" disabled /></div>
                </a-col>
                <a-col :span="12">
                  <span>{{ $t("base.question.answer") }}{{ index + 1 }}: </span>
                  <div>
                    <a-input
                      v-model="item.answer"
                      :placeholder="$t('base.question.placeholder')"
                    />
                  </div>
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-form-model>
          <a-empty
            v-else
            :image="simpleImage"
            :description="$t('base.question.not_set')"
          />
        </template>
      </div>

      <div class="next">
        <a-button style="width: 440px" type="primary" @click="handleNext">{{
          $t("base.btn.next_step")
        }}</a-button>
      </div>
    </div>
    <a-modal
      title="短信校验"
      style="width: 300px"
      :visible="visible"
      :centered="true"
      @ok="handleValidOk"
      @cancel="handleValidCancel"
    >
      <div style="display: flex; align-items: center">
        <a-input
          v-model="captcha"
          :placeholder="$t('base.captcha.img_placeholder')"
          style="height: 40px"
        />
        <img
          class="valid-mask-img"
          :src="validMaskImage"
          alt=""
          @click="getValidMask"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Empty } from "ant-design-vue";
import { commonAPI } from "@/apis";

export default {
  props: {
    safeSetInfo: { type: Object, default: () => {} },
  },
  data() {
    return {
      current: 1,
      defaultTabs: [
        { key: 1, name: this.$t("login.forget.safe_phone"), value: "3" },
        { key: 2, name: this.$t("login.forget.safe_email"), value: "2" },
        { key: 3, name: this.$t("login.forget.safe_question"), value: "1" },
      ],
      tabs: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      phoneForm: { account: "", captcha: "" },
      mailForm: { account: "", captcha: "" },
      phoneRules: {
        account: [
          { required: true, message: this.$t("base.mobile.placeholder") },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t("base.mobile.error_tip"),
          },
        ],
        captcha: [
          { required: true, message: this.$t("base.captcha.placeholder") },
        ],
      },
      mailRules: {
        account: [
          { required: true, message: this.$t("base.email.placeholder") },
          {
            pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
            message: this.$t("base.email.error_tip"),
          },
        ],
        captcha: [
          { required: true, message: this.$t("base.captcha.placeholder") },
        ],
      },
      qusForm: { qusList: [] },
      objInfo: {},
      count: 60,
      captcha: "",
      captchaKey: "",
      validMaskImage: "",
      visible: false,
    };
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  created() {
    // 设置可用方式
    this.defaultTabs.forEach((el) => {
      let flag = this.safeSetInfo.zhmmfs.includes(el.value);
      if (flag) {
        this.tabs.push(el);
      }
    });
    this.current = this.tabs[0].key;
    // 获取第一步存储的信息
    let obj = JSON.parse(localStorage.getItem("FORGET_INFO"));
    this.objInfo = { ...obj };
    // 获取问题验证
    this.getSelfInfo();
  },
  methods: {
    async getValidMask() {
      this.$refs.phoneForm.validateField("account", async (message) => {
        if (!message) {
          this.visible = true;
          this.captcha = undefined;
          this.captchaKey = undefined;
          const { code, data } = await commonAPI.getAction(
            "/user/active/captcha"
          );
          if (code === 0) {
            this.validMaskImage = data.image;
            this.captchaKey = data.captchaKey;
          } else {
            this.visible = false;
          }
        }
      });
    },
    handleValidOk() {
      if (this.captcha) {
        this.handleVerifyNew({
          noticeClassify: 2,
          captcha: this.captcha,
          businessClassify: "retrieve_password",
          captchaKey: this.captchaKey,
        });
      } else {
        this.$message.warning(this.$t("base.captcha.img_placeholder"));
      }
    },
    handleValidCancel() {
      this.visible = false;
      this.captcha = undefined;
      this.captchaKey = undefined;
    },
    // 切换
    tabChange(key) {
      if (this.current == 1) {
        this.$refs.phoneForm.resetFields();
      } else if (this.current == 2) {
        this.$refs.mailForm.resetFields();
      } else {
        this.qusForm.qusList.length && this.$refs.qusForm.resetFields();
      }
      this.current = key;
    },
    // 获取手机验证码
    getPhoneCode(obj = { captchaKey: undefined, captcha: undefined }) {
      this.$refs.phoneForm.validateField("account", (message) => {
        if (!message) {
          let params = {
            noticeClassify: "2",
            businessClassify: "retrieve_password",
            account: this.phoneForm.account,
            ...obj,
          };
          this.handleVerify(params);
        } else {
          return false;
        }
      });
    },
    async handleVerifyNew(obj) {
      let params = {
        noticeClassify: obj.noticeClassify,
        account:
          obj.noticeClassify == 1
            ? this.mailForm.account
            : this.phoneForm.account,
        userName: this.objInfo.username,
        ...obj,
      };
      const { code } = await commonAPI.postAction(
        "/send/msg/verifyUserInfoNew",
        params
      );
      if (code == 0) {
        this.handleValidCancel();
        this.getCodeApi(params);
      } else {
        this.$message.warning(
          `${params.account}${this.$t("login.activate.irrelevant")}`
        );
      }
    },
    // 验证手机邮箱
    async handleVerify(obj) {
      let params = {
        noticeClassify: obj.noticeClassify,
        account:
          obj.noticeClassify == 1
            ? this.mailForm.account
            : this.phoneForm.account,
        userName: this.objInfo.username,
      };
      const { code } = await commonAPI.postAction(
        "/send/msg/verifyUserInfo",
        params
      );
      if (code == 0) {
        this.getCodeApi(obj);
      } else {
        this.$message.warning(
          `${params.account}${this.$t("login.activate.irrelevant")}`
        );
      }
    },
    // 获取邮箱验证码
    getMailCode() {
      this.$refs.mailForm.validateField("account", (message) => {
        if (!message) {
          let params = {
            noticeClassify: "1",
            businessClassify: "retrieve_password",
            account: this.mailForm.account,
          };

          this.handleVerify(params);
        } else {
          return false;
        }
      });
    },
    async getCodeApi(params) {
      const { code, message } = await commonAPI.getAction(
        "/send/msg/sendCaptcha",
        params
      );
      if (code == 0) {
        this.$message.success(message);
        // 开启倒计时
        this.count--;
        const timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.count = 60;
            clearInterval(timer);
          }
        }, 1000);
      } else {
        this.$message.error(message);
      }
    },
    // 下一步
    handleNext() {
      if (this.current == 1) {
        this.$refs.phoneForm.validate((valid) => {
          if (valid) {
            let params = {
              account: this.phoneForm.account,
              noticeClassify: "2",
              businessClassify: "retrieve_password",
              captcha: this.phoneForm.captcha,
            };
            this.nextCodeApi(params);
          } else {
            return false;
          }
        });
      } else if (this.current == 2) {
        this.$refs.mailForm.validate((valid) => {
          if (valid) {
            let params = {
              account: this.mailForm.account,
              noticeClassify: "1",
              businessClassify: "retrieve_password",
              captcha: this.mailForm.captcha,
            };
            this.nextCodeApi(params);
          } else {
            return false;
          }
        });
      } else {
        if (!this.qusForm.qusList.length) {
          this.$message.warning(this.$t("login.forget.no_question"));
          return;
        }
        this.$refs.qusForm.validate((valid) => {
          if (valid) {
            let params = {
              userName: this.objInfo.username,
              questionVos: this.qusForm.qusList,
            };
            this.nextQusApi(params);
          } else {
            return false;
          }
        });
      }
    },
    // 验证验证码
    async nextCodeApi(params) {
      const { code, message } = await commonAPI.getAction(
        "/user/active/checkCaptcha",
        params
      );
      if (code == 0) {
        this.$message.success(message);
        this.$emit("next", 2, params);
      } else {
        this.$message.error(message);
      }
    },
    // 获取自己的密保问题
    async getSelfInfo() {
      const { code, data } = await commonAPI.getAction(
        `/users/getPwdQuestionByUser/${this.objInfo.username}`
      );
      if (code == 0) {
        let arr = data || [];
        arr.forEach((el) => {
          this.qusForm.qusList.push({
            name: el.question,
            question: el.id,
            answer: "",
          });
        });
      }
    },
    // 验证密保问题
    async nextQusApi(params) {
      const { code, message } = await commonAPI.postAction(
        "/password/reset/checkSecurityQuestion",
        params
      );
      if (code == 0) {
        this.$message.success(message);
        this.$emit("next", 2);
      } else {
        this.$message.error(message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.next {
  padding-top: 20px;
  text-align: center;
}
.desc {
  text-align: center;
  & > div:first-child {
    color: #333333;
  }
  & > div:last-child {
    margin-top: 10px;
    color: #9f9f9f;
  }
}

.main {
  margin-top: 20px;
}

.mulit-s {
  display: flex;
  align-items: center;
  .man-all {
    flex: 1;
  }

  .yan-mask {
    width: 100px;
    margin-left: 12px;
    & > * {
      width: 100%;
    }
  }
}

.flex_form::v-deep {
  .ant-col {
    display: flex;
    & > span {
      width: auto;
      padding-right: 10px;
    }
    & > div {
      flex: 1;
    }
  }
  .ant-input[disabled] {
    color: rgba(0, 0, 0, 0.6);
  }
  .has-error .ant-form-explain {
    padding-left: calc(50% + 109px);
  }
}

.valid-type {
  margin-top: 35px;
  display: flex;
  justify-content: space-evenly;
  color: #040849;
  & > div {
    padding: 10px 30px;
    cursor: pointer;
  }
}
.active {
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

.qu-label {
  ::v-deep .ant-form-item-label {
    label {
      display: none !important;
    }
  }
}
</style>
